

export const numFormatter = (num) => {
  // Formats number as 9, 12K, 1M, 10K
  if(num > 999 && num < 1000000){
    return (num/1000).toFixed(1) + 'K'; // convert to K for number from > 1000 < 1 million 
  } else if(num > 1000000){
    return (num/1000000).toFixed(1) + 'M'; // convert to M for number from > 1 million 
  } else {
    return num; // if value < 1000, nothing to do
  }
}


export const num2words = (n) => {
  const num = "zero one two three four five six seven eight nine ten eleven twelve thirteen fourteen fifteen sixteen seventeen eighteen nineteen".split(" ");
  const tens = "twenty thirty forty fifty sixty seventy eighty ninety".split(" ");
  if (n < 20) return num[n];
  var digit = n%10;
  if (n < 100) return tens[~~(n/10)-2] + (digit? "-" + num[digit]: "");
  if (n < 1000) return num[~~(n/100)] +" hundred" + (n%100 == 0? "": " and " + num2words(n%100));
  return num2words(~~(n/1000)) + " thousand" + (n%1000 != 0? " " + num2words(n%1000): "");
}


export const capitalize = (s) => {
  if (!s) return null
  return `${s?.slice(0, 1)?.toUpperCase()}${s?.slice(1, s?.length)}`
}
  
export const pluralize = (count, noun, suffix='s') => `${noun}${count !== 1 ? suffix : ''}` // pluralize(3, 'source')  // simple pluralize, not for all words


export const textNumeral = (number, useOf=false) => {
  const length = number.toString().length
  let numeral = ''
  let posttext = useOf ? ' of' : ''  // 'dozens of', but 'several'

  if (number === 0) {
    numeral ='no'
    posttext = ''
  } else if (length===1) {
    numeral = "several"
    posttext = ''
  } else if (length===2) {
    numeral =  "dozens"
  } else if (length===3) { 
    numeral = "hundreds" 
  } else if (length>=3 && length<=6) { 
    numeral = "thousands" 
  } else if (length>=7 && length<=9) {
    numeral = "millions"
  } else {
    numeral = "many"
  }
  return `${numeral}${posttext}`
}


export const firstName = (fullName) => {
  return fullName?.split(' ')?.slice(0, -1)?.join(' ')
}


export const lastName = (fullName) => {
  return fullName?.split(' ')?.slice(-1)?.join(' ')  
}